/**
 * Swiper carousel configuration — used for the "My Queue" homepage carousel.
 * https://swiperjs.com/
 */

// Swiper CSS
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// Swiper JS
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

let queueSwiperInstance = null;

export function initQueueCarousel() {
  const container = document.querySelector('.queue-swiper');
  if (!container) return;

  if (queueSwiperInstance) {
    queueSwiperInstance.destroy(true, true);
    queueSwiperInstance = null;
  }

  const slideCount = container.querySelectorAll('.swiper-slide').length;

  queueSwiperInstance = new Swiper(container, {
    modules: [Navigation, Pagination],

    slidesPerView: 1.15,
    spaceBetween: 16,
    loop: slideCount > 1,

    breakpoints: {
      640: {
        slidesPerView: 2.2,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 3.2,
        spaceBetween: 24,
      },
      1280: {
        slidesPerView: 4,
        spaceBetween: 24,
      },
    },

    pagination: {
      el: '.queue-swiper-pagination',
      clickable: true,
    },

    navigation: {
      nextEl: '.queue-swiper-next',
      prevEl: '.queue-swiper-prev',
    },
  });

  // Nothing to render — avoid an empty/broken carousel shell.
  container.style.display = slideCount === 0 ? 'none' : '';
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initQueueCarousel);
} else {
  initQueueCarousel();
}

// Re-initialize after the homepage feed is refreshed live (see queue-home-feed.js)
document.addEventListener('queue:home-feed-updated', initQueueCarousel);

